import { useLocation } from "react-router-dom";
import { useContext } from "react";
import { toast } from "react-toastify";
import { Context } from "../../../../index";

export function useModuleUpdate() {
  const location = useLocation();
  const { store } = useContext(Context);

  const refreshData = () => {
    if (location.pathname.startsWith("/inplants")) {
      store.loadPlantData();
    } else if (location.pathname.startsWith("/modules")) {
      const role = store.user.role;
      role === "root" ? store.getAllModules() : store.getOrgModules();
    }
  };

  const handleError = (error: any) => {
    if (!error.response) {
      toast.error("Нет связи с сервером. Проверьте подключение.", {
        autoClose: 10000,
      });
    } else {
      // Без номера (в реестр Оркестратору): сервер отвечает то `{error}`
      // (`module-controller`), то `{message}` — называем причину любым из них.
      // Прежде читалось только `message`, и отказ «адрес 1–247» показывался
      // оператору как «Неизвестная ошибка сервера».
      const data = error.response?.data;
      const msg = data?.error || data?.message || "Неизвестная ошибка сервера";
      toast.warning(msg, { autoClose: 10000 });
    }
  };

  const handleResponse = (response: any): boolean => {
    if (
      response?.data?.status === "accepted" ||
      response?.data?.status === "rejected"
    ) {
      const toastMessage =
        response.data.status === "accepted"
          ? "Таймер обновлён"
          : "Изменение таймера отклонено устройством";

      toast[response.data.status === "accepted" ? "success" : "warning"](
        toastMessage,
        {
          position: "top-right",
          autoClose: response.data.status === "accepted" ? 5000 : 8000,
        },
      );

      return response.data.status === "accepted";
    }

    refreshData();

    const { success, message, error, warning } = response.data;

    if (success === false) {
      toast.warning(error || message || "Неизвестная ошибка", {
        position: "top-right",
        autoClose: 10000,
      });
      return false;
    }

    const toastMessage = message || "Изменения сохранены";
    const isTimeout = response.status === 202;

    if (isTimeout || warning) {
      toast.warning(toastMessage, {
        position: "top-right",
        autoClose: 8000,
      });
    } else {
      toast.success(toastMessage, {
        position: "top-right",
        autoClose: 5000,
      });
    }

    return true;
  };

  return { handleResponse, handleError };
}
